
// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

// VMX LOGO
import vmxLogo from './VerimatrixLogoWhite.png'

// ICONS
import vcasIcon from './icons/vcas-icon.svg'
import analyticsIcon from './icons/analytics-icon.svg'
import codeProtectionIcon from './icons/code-protection-icon.svg'
import multiDRMIcon from './icons/multi-drm-icon.svg'
import ntitleMeIcon from './icons/n-title-me-icon.svg'
import watermarkingIcon from './icons/watermarking-icon.svg'
import strongAuthenticationIcon from './icons/strong-authentication-icon.svg'
import contentDistributionIcon from './icons/content-distribution-icon.svg'
import adminIcon from './icons/admin-icon.svg'
import userIcon from './icons/user-icon.svg'
import systemStatusIcon from './icons/system-status-icon.png'

// EXPORTS
export const VerimatrixLogo = vmxLogo
export const vcas = vcasIcon
export const analytics = analyticsIcon
export const codeProtection = codeProtectionIcon
export const multiDRM = multiDRMIcon
export const ntitleMe = ntitleMeIcon
export const watermarking = watermarkingIcon
export const strongAuthentication = strongAuthenticationIcon
export const contentDistribution = contentDistributionIcon
export const admin = adminIcon
export const user = userIcon
export const systemStatus = systemStatusIcon
